import { useContext } from 'react'

import KeepDirtyOnReinitializeContext from '../../contexts/DirtyStateContext'

export const useKeepDirtyOnReinitialize = () => {
  const context = useContext(KeepDirtyOnReinitializeContext)

  return context
}
